// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as VGSVault$OrcaPaymentPage from "./VGSVault.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";
import * as CardPayment$OrcaPaymentPage from "./CardPayment.bs.js";
import * as CardCVCElement$OrcaPaymentPage from "../CardCVCElement.bs.js";
import * as CommonCardProps$OrcaPaymentPage from "../Hooks/CommonCardProps.bs.js";

function CardsSDK(props) {
  var __cvcOnly = props.cvcOnly;
  var cvcOnly = __cvcOnly !== undefined ? __cvcOnly : false;
  var loggerState = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.loggerAtom);
  var vaultCredentials = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.vaultCredentials);
  var match = CommonCardProps$OrcaPaymentPage.useCardForm(loggerState, "Payment");
  var cvcProps = match.cvcProps;
  var expiryProps = match.expiryProps;
  var cardProps = match.cardProps;
  if (typeof vaultCredentials !== "object") {
    if (cvcOnly) {
      return null;
    } else {
      return React.createElement(CardPayment$OrcaPaymentPage.make, {
                  cardProps: cardProps,
                  expiryProps: expiryProps,
                  cvcProps: cvcProps,
                  isInsideCardSDK: true
                });
    }
  } else if (vaultCredentials.TAG === "HyperswitchVault") {
    if (cvcOnly) {
      return React.createElement(CardCVCElement$OrcaPaymentPage.make, {
                  cvcProps: cvcProps,
                  paymentType: "CardCVCElement",
                  isVaultCvcFlow: true
                });
    } else {
      return React.createElement(CardPayment$OrcaPaymentPage.make, {
                  cardProps: cardProps,
                  expiryProps: expiryProps,
                  cvcProps: cvcProps,
                  isInsideCardSDK: true
                });
    }
  } else {
    return React.createElement(VGSVault$OrcaPaymentPage.make, {
                cvcOnly: cvcOnly
              });
  }
}

var make = CardsSDK;

export {
  make ,
}
/* jotai Not a pure module */
